<template>
  <b-dropdown
    right
    split
    alt="View Location"
    title="View Location"
    :split-to="{ name: 'LocationDetails', params: { id: locationId } }"
  >
    <template slot="button-content"
      ><font-awesome-icon icon="eye" /> View</template
    >
    <b-dropdown-item
      :to="{ name: 'LocationTrends', params: { id: locationId } }"
    >
      <i class="fa fa-chart-line mr-1 mr-lg-2"></i> Trends</b-dropdown-item
    >
    <b-dropdown-divider
      v-if="
        projectId &&
        membershipMap[projectId] &&
        membershipMap[projectId].isManager
      "
    ></b-dropdown-divider>
    <b-dropdown-item
      v-if="
        projectId &&
        membershipMap[projectId] &&
        membershipMap[projectId].isManager
      "
      :to="{ name: 'LocationAssignments', params: { id: locationId } }"
      ><i class="fa fa-thumb-tack mr-1 mr-lg-2"></i>Assignments</b-dropdown-item
    >
    <b-dropdown-item
      v-if="
        projectId &&
        membershipMap[projectId] &&
        membershipMap[projectId].isManager
      "
      :to="{ name: 'LocationEdit', params: { id: locationId } }"
      ><i class="fa fa-edit mr-1 mr-lg-2"></i>Edit</b-dropdown-item
    >
    <b-dropdown-divider
      v-if="
        projectId &&
        membershipMap[projectId] &&
        membershipMap[projectId].isManager
      "
    ></b-dropdown-divider>
    <b-dropdown-item
      v-if="
        projectId &&
        membershipMap[projectId] &&
        membershipMap[projectId].isManager
      "
      :to="{ name: 'LocationDelete', params: { id: locationId } }"
      ><i class="fa fa-trash mr-1 mr-lg-2"></i>Delete</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LocationNavigationDropdown",
  props: {
    locationId: {
      type: String,
      required: false,
    },
    projectId: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      membershipMap: "user/profile/membershipMap",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
